<template>
    <div class="language-view" full-height>
        <!-- <v-toolbar flat fixed>
            <v-toolbar-title>{{ $t('languageDialog.title') }}</v-toolbar-title>
        </v-toolbar> -->

        <div>
            <div class="center-align" style="margin: 24px 16px 16px;">
                <p class="title" style="line-height:32px !important;font-size: 1.5rem !important;color: rgba(0,0,0,0.87);">
                    {{ $t('languageDialog.chooseTitle') }}
                </p>
                <p light-opacity-color>
                    {{ $t('languageDialog.chooseSubtitle') }}
                </p>
            </div>

            <v-list two-line nopadding style="margin: 24px 16px 16px;">
                <template v-for="(opt, idx) in options">
                    <v-list-item :key="opt.code + idx" @click="fn_select(opt.code)" style="min-height: 68px;border: 1px #ddd solid;border-radius: 12px;margin-bottom: 16px;">
                        <!-- <v-list-item-action class="mr-3">
                            <v-icon class="primary-color">
                                {{ pendingLang === opt.code ? 'radio_button_checked' : 'radio_button_unchecked' }}
                            </v-icon>
                        </v-list-item-action> -->
                        <v-list-item-avatar style="background: #eee;font-weight: 500;height:48px;min-width: 48px;width: 48px;">
                            {{ opt.avatarCode }}
                        </v-list-item-avatar>
                        <v-list-item-content style="padding: 12px 0;">
                            <v-list-item-title style="font-size: 18px;line-height: 1.5;">
                                {{ $t(opt.labelKey) }}
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action class="mr-3">
                            <v-icon class="primary-color">
                                {{ pendingLang === opt.code ? 'radio_button_checked' : 'radio_button_unchecked' }}
                            </v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <!-- <v-divider :key="'d-' + opt.code" v-if="idx < options.length - 1"></v-divider> -->
                </template>
            </v-list>

        </div>

        <v-footer style="position: fixed;bottom: 0;width: 100%;padding: 16px 16px 24px;background: #fff;">
            <v-btn color="primary" style="height: 48px;" block @click="fn_continue">Continue</v-btn>
        </v-footer>
    </div>
</template>

<script>
import { applyLanguage } from '../../plugins/global_translator'

export default {
    data () {
        return {
            pendingLang: 'en',
            options: [
                { code: 'en',       labelKey: 'languageDialog.english',  subKey: 'languageDialog.englishSub', avatarCode:'E' },
                { code: 'hi',       labelKey: 'languageDialog.hindi',    subKey: 'languageDialog.hindiSub', avatarCode:'हिं' },
                { code: 'hinglish', labelKey: 'languageDialog.hinglish', subKey: 'languageDialog.hinglishSub', avatarCode:'H' },
            ]
        }
    },
    methods: {
        fn_select (code, goToLogin) {
            this.pendingLang = code;
            const self = this;
            this.$loadLocale(code).then(function(){
                self.$root.selectedLanguage = code;
                applyLanguage(code);
                if (goToLogin) {
                    self.fn_goToLogin();
                }
            });
            let obj = {language: code};
            this.$root.fn_saveLocalData({LocalKey:'appLanguage',LocalValue:JSON.stringify(obj)});
        },
        fn_continue () {
            this.fn_select(this.pendingLang, true);
        },
        fn_goToLogin () {
            this.$router.push({path:'/registration/business/login'});
        },
        fn_goBack () {
            this.exitApp ? this.exitApp() : this.$router.go(-1);
        }
    },
    mounted () {
        this.pendingLang = this.$root.selectedLanguage || 'en';
        window.js_globals.fn_onBackPress = this.fn_goBack;
    },
    beforeRouteEnter (to, from, next) { 
        // If a language was already saved on a previous run, skip this screen.
        next(vm => {
            vm.$root.fn_getLocalData('appLanguage', function(response){
                // if (!response || response === 'null') return next();
                // var lang = response;
                let langObj = null
                try { 
                    langObj = JSON.parse(response); 
                } catch(e) { /* plain string */ }
                // try { lang = JSON.parse(response); } catch(e) { /* plain string */ }
                // if (!lang || lang === 'null') {
                //     lang = 'en';
                //     // return next();
                // }
                if (!langObj || langObj === 'null' || (langObj && !langObj.language)) {
                    // return next();
                    langObj = {language: 'en'};
                }
                vm.$loadLocale(langObj.language).then(function(){
                    vm.$root.selectedLanguage = langObj.language;
                    applyLanguage(langObj.language);
                    console.log(from);
                    if(from.path == '/' && response && response !== 'null'){
                        console.log('Going to login');
                        vm.fn_goToLogin();
                    }
                    else{
                        /*global AndroidRoutingTest*/
                        AndroidRoutingTest.onPageLoadCompleted('1', JSON.stringify({}));
                        next();
                    }
                });
            });
        })
    }
}
</script>
